import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MorningLayout from "../../morningLayout";
import Morning_Transport from "assets/morning/transport.png";
import SelectSubmenu from "components/SelectSubmenu";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import { useAppContext } from "context/AppContext";

type LayoutProps = {
    children: React.ReactNode;
};

const menuItems = [
    { label: "모닝 서비스", path: "/transport/morning-service" },
    { label: "전국센터조직도", path: "/transport/center-network" },
    { label: "주요 CLIENT 현황", path: "/transport/clients" },
];

const TransportLayout = ({ children }: LayoutProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isApp } = useAppContext();
    const responsive1100 = useMediaQuery(1100);

    const activeIndex = useMemo(() => {
        return menuItems.findIndex(item => item.path === location.pathname);
    }, [location.pathname]);

    return (
        <div className={`flex flex-col relative ${!isApp && "mt-[116px]"} flex-1`}>
            <MorningLayout>
                {!isApp && (
                    <div
                        className="relative bg-cover bg-top flex flex-col items-center justify-center bg-no-repeat h-60"
                        style={{ backgroundImage: `url(${Morning_Transport})` }}
                    >
                        <div className="flex flex-col items-center text-white pb-[50px]">
                            <p className="text-[40px] font-bold pb-[3px]">운송 서비스</p>
                            <p>마음까지 전해주는 일신모닝택배</p>
                        </div>

                        <div className="flex bottom-0 absolute w-full h-[50px] bg-[rgba(21,34,65,0.85)] text-white justify-center">
                            {/* 1100 이하/이상 */}
                            {responsive1100 ? (
                                <SelectSubmenu menuItems={menuItems} activeIndex={activeIndex} />
                            ) : (
                                <>
                                    {menuItems.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`w-[200px] p-2.5 flex items-center justify-center border-l border-gray-600 text-[17px] cursor-pointer ${
                                                activeIndex === index
                                                    ? "bg-[#f4f4f4] text-[#0e0057] relative after:absolute after:bottom-[-1px] after:left-0 after:w-full after:h-[1px] after:bg-[#f4f4f4]"
                                                    : "text-white"
                                            } ${index === menuItems.length - 1 ? "border-r" : ""}`}
                                            onClick={() => navigate(item.path)}
                                        >
                                            {item.label}
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                )}
                {/* <div className="w-full">{children}</div> */}
                {children}
            </MorningLayout>
        </div>
    );
};

export default TransportLayout;
